import { render, staticRenderFns } from "./blockedrequests.vue?vue&type=template&id=66053f14&"
import script from "./blockedrequests.vue?vue&type=script&lang=js&"
export * from "./blockedrequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports